import React, {memo, useEffect, useState} from 'react';
import {ActivityIndicator, Platform, View} from 'react-native';

import { StyleSheet } from 'react-native';

import {SVGIcon, RNEButton, RNEText} from '../../components';
import { colorPalette, colors } from '../../../core/config/color.config';
import { totalSize, width, height } from 'react-native-dimension';

interface LogoutConfirmationModalProps {
  title?: string;
  primaryBtnText?:string;
  secondaryBtnText?: string;
  isLoading?: boolean;
  onCancel?: () => void;
  onConfirm?: () => void;
  textStyle?: any;
}

function ConsultationCancelConfirmationModal({
  // title = 'Are you sure you want to cancel the consultation request?',
  title = 'Are you sure you want to cancel this request?',
  primaryBtnText = 'Yes',
  secondaryBtnText = 'No',
  isLoading = false,
  onCancel = () => {},
  onConfirm = () => {},
  textStyle = {}
}: LogoutConfirmationModalProps
) {
  
  // const [hideButton, setHideButton] = useState(false);

  // useEffect(()=>{

  //   setHideButton(isLoading);

  // },[isLoading])



  return (
    <View style={rneStyles.root}>
      <RNEText
        label={title || "Are you sure you want to cancel the consultation request?"}
        variant="header"
        align="center"
        weight="bold"
        color={colors.midnightBlue.regular}
        style={{fontSize: totalSize(2.1), fontFamily:'Quicksand-Bold', ...textStyle}}
      />

      <View style={rneStyles.actionContainer}>
        {
          !isLoading && (
            <View style={rneStyles.buttonContainer}>
              <RNEButton
                title={secondaryBtnText}
                color="secondary"
                onPress={onCancel}
                style={rneStyles.buttonStyle}
                titleStyle={{fontSize:totalSize(1.5), color: colors.brightYellow.regular}}
                variant="outlined"
                height={40}
              />
            </View>
          )
        }

        {
          isLoading ? (
            <View>
               <ActivityIndicator size={totalSize(3.5)} color={colors.brightYellow.regular} />
            </View>
          ) : (
            <RNEButton
              title={primaryBtnText}
              color="secondary"
              onPress={onConfirm}
              titleStyle={{fontSize:totalSize(1.5)}}
              style={rneStyles.buttonStyle}
              height={40}
            />
          )
        }

        {/* <RNEButton
          title="Cancel Request"
          color="secondary"
          onPress={onConfirm}
          style={rneStyles.buttonStyle}
          height={40}
        /> */}
      </View>
    </View>
  );
}

const rneStyles = StyleSheet.create(({
  root: {
    maxWidth: 540,
    padding: Platform.OS === 'web' ? 60 : 32,
    paddingTop: height(2),
    paddingBottom: height(2),
    justifyContent: 'center',
    
  },
  actionContainer: {
    marginTop: height(2.4),
    justifyContent: 'center',
    flexDirection: 'row',
  },
  buttonContainer: {
    marginRight: width(5),
  },
  buttonStyle: {
    width: width(25),
    paddingRight: width(3),
    paddingLeft: width(3),
  },
}));

export default memo(ConsultationCancelConfirmationModal);
